"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "ຫຼັກສູດທັງໝົດ",
    "className": "ຊື່ກອງປະຊຸມທາງວິຊາການ",
    "continue": "ສືບຕໍ່",
    "courseChapter": "ບົດ",
    "courseEvaluate": "ການປະເມີນຜົນ",
    "courseHours": "ເຄຣດິດ",
    "courseInfo": "ລາຍລະອຽດ",
    "courseNote": "ບັນທຶກ",
    "coursesCategory": "ປະເພດຫຼັກສູດ",
    "electiveCourses": "ຫຼັກສູດທາງເລືອກ",
    "pages": "ໜ້າ",
    "relatedCourses": "ຫຼັກສູດທີ່ກ່ຽວຂ້ອງ",
    "requiredCourses": "ການບັນຍາຍ",
    "searchTips": "ກະລຸນາປ້ອນຊື່ຫຼັກສູດ",
    "studentsNum": "ຜູ້ຊົມ",
    "teachersDesc": "ອາຈານ",
    "newCourse": "ຫລັກສູດ ໃໝ່ ລ້າສຸດ"
  },
  "footer_zlb": {
    "aboutUs": "ກ່ຽວກັບພວກເຮົາ",
    "downLoad": "ດາວໂຫຼດ APP",
    "qr": "ລະຫັດ QR"
  },
  "global_zlb": {
    "am": "ກ່ອນທ່ຽງ",
    "night": "ຕອນແລງ",
    "pm": "ຫຼັງທ່ຽງ"
  },
  "header_zlb": {
    "accoutPw": "ລະຫັດຜ່ານບັນຊີ",
    "curDis": "ກຳລັງດຳເນີນການ",
    "curUser": "ຜູ້ໃຊ້ປັດຈຸບັນ",
    "edit": "ອັບເດດ",
    "helpCenter": "ສູນຊ່ວຍເຫຼືອ",
    "hisDis": "ປະຫວັດ",
    "index": "ໜ້າທຳອິດ",
    "joinStore": "ເພີ່ມໃສ່ລາຍການທີ່ມັກ",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "ຂໍ້ຄວາມ",
    "setIndex": "ຕັ້ງເປັນໜ້າທຳອິດ",
    "userImg": "ຮູບໂປຣໄຟລ໌"
  },
  "index_zlb": {
    "discuss": "ການປະຊຸມທາງວິຊາການ",
    "find": "ຄົ້ນພົບ",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "ຂ້າພະເຈົ້າ"
  },
  "info_zlb": {
    "admin": "ຜູ້ດູແລລະບົບ",
    "hasAgenda": "ທ່ານໄດ້ເຂົ້າຮ່ວມວາລະການປະຊຸມແລ້ວ.",
    "noDown": "ບໍ່ມີເອກະສານຄັດຕິດໃຫ້ດາວໂຫຼດ!",
    "pleaseInp": "ກະລຸນາໃສ່",
    "submit": "ສົ່ງສຳເລັດແລ້ວ!",
    "withinTime": "ວຽກຍັງບໍ່ເລີ່ມ",
    "noSubmitWork": "ບໍ່ໄດ້ສົ່ງວຽກ"
  },
  "login_zlb": {
    "accountLogin": "ເຂົ້າສູ່ລະບົບ",
    "accountNotEmpty": "ຕ້ອງຕື່ມບັນຊີ",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "ຍົກເລີກ",
    "captchaNotEmpty": "ຕ້ອງຕື່ມລະຫັດຢືນຢັນ",
    "captchaTips": "ລະຫັດຢືນຢັນບໍ່ຖືກຕ້ອງ",
    "changeEmail": "ອັບເດດອີເມວ",
    "changeEmailSuccess": "ອັບເດດທີ່ຢູ່ອີເມວສຳເລັດແລ້ວ.",
    "changeEmailSuccessTips": "ທ່ານໄດ້ອັບເດດອີເມວຂອງທ່ານສຳເລັດແລ້ວ.",
    "Confirm": "ຢືນຢັນ",
    "currentEmail": "ອີເມວປັດຈຸບັນ",
    "emailCaptcha": "ລະຫັດຢືນຢັນອີເມວ",
    "emailCaptchaEmpty": "ລະຫັດຢືນຢັນອີເມວບໍ່ສາມາດວ່າງເປົ່າໄດ້",
    "encryEmail": "ອີເມວຮັກສາຄວາມປອດໄພ",
    "error": "ຂໍ້ຜິດພາດລະຫັດຢືນຢັນ",
    "forget": "ລືມລະຫັດຜ່ານ",
    "formerEamil": "ອີເມວເດີມ",
    "incorrectTips": "ຂໍ້ຜິດພາດໃນການປ້ອນຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານ",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "ອີເມວໃໝ່",
    "newEmailBinded": "ອີເມວໃໝ່ໄດ້ຖືກເຊື່ອມໂຍງກັບບັນຊີຜູ້ໃຊ້ຂອງທ່ານ",
    "newEmailEmpty": "ອີເມວໃໝ່ບໍ່ສາມາດວ່າງເປົ່າໄດ້",
    "newEmailFomat": "ຮູບແບບອີເມວໃໝ່ບໍ່ຖືກຕ້ອງ",
    "newEmailSupport": "ທີ່ຢູ່ອີເມວເກົ່າ ແລະ ໃໝ່ບໍ່ກົງກັນ",
    "prevStep": "ຂັ້ນຕອນສຸດທ້າຍ",
    "nextStep": "ຂັ້ນຕອນຕໍ່ໄປ",
    "reset": "ຕັ້ງໃໝ່",
    "loginNow": "ເຂົ້າສູ່ລະບົບຕອນນີ້",
    "resetSuccess": "ຕັ້ງໃໝ່ສຳເລັດ",
    "resetSuccessTips": "ທ່ານໄດ້ຕັ້ງລະຫັດຜ່ານໃໝ່ສຳເລັດແລ້ວ. ກະລຸນາເຂົ້າສູ່ລະບົບ",
    "msgCaptcha": "ລະຫັດຢືນຢັນ SMS",
    "getCaptcha": "ຮັບລະຫັດຢືນຢັນ",
    "resetPassword": "ຕັ້ງລະຫັດຜ່ານໃໝ່",
    "loginFail": "ເຂົ້າສູ່ລະບົບລົ້ມເຫຼວ, ກະລຸນາລອງອີກຄັ້ງ!",
    "failTips": "ການຢືນຢັນລົ້ມເຫຼວ",
    "inputUserName": "ຊື່ຜູ້ໃຊ້",
    "goHome": "ໄປທີ່ໜ້າທຳອິດ",
    "passwordFormat": "ລະຫັດຜ່ານຕ້ອງເປັນຕົວເລກ 8-32 ຫຼັກ ແລະ ປະກອບດ້ວຍຕົວເລກ ແລະ ຕົວອັກສອນພິມໃຫຍ່ ແລະ ພິມນ້ອຍ.",
    "surePasswordEmpty": "ຢືນຢັນລະຫັດຜ່ານບໍ່ສາມາດວ່າງເປົ່າໄດ້",
    "confirmNot": "ລະຫັດຜ່ານ ແລະ ລະຫັດຜ່ານຢືນຢັນບໍ່ສອດຄ່ອງກັນ",
    "changePasswordSuccess": "ອັບເດດລະຫັດຜ່ານສຳເລັດແລ້ວ",
    "continueLogin": "ເຂົ້າສູ່ລະບົບອີກຄັ້ງ",
    "orError": "ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ",
    "orgEmailEmpty": "ອີເມວເດີມບໍ່ສາມາດວ່າງເປົ່າໄດ້",
    "orgEmailFormat": "ຮູບແບບອີເມວເດີມບໍ່ຖືກຕ້ອງ",
    "orgEmailNot": "ທີ່ຢູ່ອີເມວເດີມບໍ່ຖືກຕ້ອງ",
    "passWord": "ລະຫັດຜ່ານ",
    "surePassword": "ຢືນຢັນລະຫັດຜ່ານ",
    "passwordBits": "ລະຫັດຜ່ານຕ້ອງມີຄວາມຍາວຢ່າງໜ້ອຍ 6 ອັກຂະຫຼະ",
    "passwordNotEmpty": "ຕ້ອງໃສ່ລະຫັດຜ່ານ",
    "pWord": "ລະຫັດຜ່ານ",
    "sign": "ເຂົ້າສູ່ລະບົບ",
    "uName": "ບັນຊີ",
    "userName": "ຊື່ຜູ້ໃຊ້",
    "validate": "ລະຫັດຢືນຢັນ",
    "verification": "ກະລຸນາດຳເນີນການກວດສອບດ້ານລຸ່ມນີ້ໃຫ້ສຳເລັດ",
    "appdownload": "ດາວໂຫຼດ App",
    "scancode": "ສະແກນລະຫັດ QR ເພື່ອດາວໂຫຼດ",
    "poor": "ອ່ອນແອ",
    "middle": "ປານກາງ",
    "strong": "ແຂງແຮງ"
  },
  "login": {
    "logout": "ອອກຈາກລະບົບສຳເລັດແລ້ວ",
    "resetLoginTips": "ທ່ານໄດ້ປ່ຽນລະຫັດຜ່ານສຳເລັດແລ້ວ, ທ່ານຕ້ອງເຂົ້າສູ່ລະບົບອີກຄັ້ງ ແລະ ອອກຈາກລະບົບໂດຍອັດຕະໂນມັດ ຫຼັງຈາກຜ່ານໄປ 3 ວິນາທີ",
    "sure": "ຢືນຢັນ",
    "cancel": "ຍົກເລີກ",
    "captchaNotEmpty": "ຕ້ອງຕື່ມລະຫັດຢືນຢັນ",
    "accountNotEmpty": "ຕ້ອງຕື່ມບັນຊີ",
    "passwordNotEmpty": "ຕ້ອງໃສ່ລະຫັດຜ່ານ",
    "inputCaptcha": "ລະຫັດຢືນຢັນ",
    "getCaptcha": "ຮັບລະຫັດຢືນຢັນ",
    "inputOrigPassword": "ກະລຸນາໃສ່ລະຫັດຜ່ານເດີມ",
    "inputNewPassowrd": "ກະລຸນາໃສ່ລະຫັດຜ່ານໃໝ່",
    "confimPassword": "ຢືນຢັນລະຫັດຜ່ານ",
    "changePassword": "ປ່ຽນລະຫັດຜ່ານ",
    "nextStep": "ຂັ້ນຕອນຕໍ່ໄປ",
    "resetPassword": "ຕັ້ງລະຫັດຜ່ານໃໝ່",
    "resetDone": "ການຕັ້ງລະຫັດຜ່ານໃໝ່ສຳເລັດແລ້ວ",
    "msgCaptcha": "ລະຫັດຢືນຢັນອີເມວ"
  },
  "look_zlb": {
    "aboutLecturer": "ຫຼັກສູດທີ່ກ່ຽວຂ້ອງ",
    "benginLearn": "ເລີມຮຽນຮູ້",
    "chapter": "ບົດ",
    "delete": "ລຶບ",
    "details": "ລາຍລະອຽດ",
    "download": "ດາວໂຫຼດ",
    "dynamic": "ຂ່າວ",
    "evaluation": "ການປະເມີນຜົນ",
    "hotDyc": "ກຳລັງນິຍົມ",
    "lecture": "ເປີດຫຼັກສູດ",
    "lecturer": "ອາຈານ",
    "lectureTest": "ປະເພດຫຼັກສູດ",
    "look": "ຄົ້ນພົບ",
    "lookAll": "ເບິ່ງທັງໝົດ",
    "note": "ບັນທຶກ",
    "score": "ຄະແນນ"
  },
  "myMessage_zlb": {
    "passwordError": "ຂໍ້ຜິດພາດໃນການປ້ອນລະຫັດຜ່ານເດີມ",
    "aboutUs": "ກ່ຽວກັບພວກເຮົາ",
    "allcourse": "ຫຼັກສູດທັງໝົດ",
    "atypism": "ລະຫັດຜ່ານສອງລະຫັດບໍ່ກົງກັນ",
    "birth": "ວັນເດືອນປີເກີດ",
    "cancel": "ຍົກເລີກ",
    "carryOut": "ສຳເລັດສົມບູນ",
    "changePassword": "ປ່ຽນລະຫັດຜ່ານ",
    "chineseName": "ຊື່ພາສາຈີນ",
    "chineseNamePlaceholder": "ກະລຸນາໃສ່ຊື່ພາສາຈີນ",
    "code": "ລະຫັດຢືນຢັນ",
    "codeError": "ຂໍ້ຜິດພາດລະຫັດຢືນຢັນ",
    "comment": "ສະແດງຄວາມຄິດເຫັນ",
    "complete": "ສຳເລັດສົມບູນ",
    "completeUserInfo": "ກະລຸນາຕື່ມຂໍ້ມູນສ່ວນບຸກຄົນໃຫ້ສຳເລັດ",
    "confirm": "ຢືນຢັນລະຫັດຜ່ານ",
    "continueStudy": "ສືບຕໍ່",
    "country": "ປະເທດ",
    "countryName": "ຊື່",
    "countryNamePlaceholder": "ກະລຸນາໃສ່ຊື່ຂອງທ່ານ",
    "countryPlaceholder": "ກະລຸນາເລືອກປະເທດ",
    "courseLearned": "ສຳເລັດສົມບູນ",
    "delete": "ລຶບ",
    "documentType": "ປະເພດເອກະສານປະຈຳຕົວ",
    "downloaded": "ດາວໂຫຼດແລ້ວ",
    "downloading": "ກຳລັງດາວໂຫຼດ",
    "eduLevel": "ລະດັບການສຶກສາ",
    "eduLevelPlaceholder": "ກະລຸນາເລືອກລະດັບການສຶກສາ",
    "email": "ອີເມວ",
    "emailCode": "ລະຫັດຢືນຢັນອີເມວ",
    "gender": "ເພດ",
    "genderPlaceholder": "ກະລຸນາເລືອກເພດ",
    "getCode": "ຮັບລະຫັດຢືນຢັນອີເມວ",
    "hasSent": "ສົ່ງແລ້ວ",
    "helpCenter": "ສູນຊ່ວຍເຫຼືອ",
    "hour": "ຊົ່ວໂມງ",
    "improveInformation": "ກະລຸນາຕື່ມຂໍ້ມູນສ່ວນບຸກຄົນຂອງທ່ານໃຫ້ສຳເລັດ",
    "joinClasses": "ໄດ້ເຂົ້າຮ່ວມຫຼັກສູດ",
    "joinDis": "ໄດ້ເຂົ້າຮ່ວມການປະຊຸມວິຊາການ",
    "learned": "ສຳເລັດ",
    "learning": "ກຳລັງດຳເນີນການ",
    "lecture": "ຫຼັກສູດ",
    "mailbox": "ອີເມວ",
    "mailboxValidate": "ການຢືນຢັນອີເມວລົ້ມເຫຼວ",
    "man": "ຊາຍ",
    "management": "ການຕັ້ງຄ່າ",
    "minutes": "x ຊົ່ວໂມງ x ນາທີ",
    "modify": "ອັບເດດ",
    "modifyEmail": "ອັບເດດອີເມວ",
    "my": "ຕົນເອງ",
    "myCertificate": "ໃບຢັ້ງຢືນຂອງຂ້າພະເຈົ້າ",
    "mycourse": "ຫຼັກສຸດຂອງຂ້າພະເຈົ້າ",
    "myDownload": "ການດາວໂຫຼດຂອງຂ້າພະເຈົ້າ",
    "myLecture": "ຫຼັກສຸດຂອງຂ້າພະເຈົ້າ",
    "myNotes": "ບັນທຶກຂອງຂ້າພະເຈົ້າ",
    "newMail": "ອີເມວໃໝ່",
    "newPassword": "ລະຫັດຜ່ານໃໝ່",
    "nextStep": "ຂັ້ນຕອນຕໍ່ໄປ",
    "orError": "ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ",
    "origin": "ຈາກ",
    "originalPassword": "ລະຫັດຜ່ານເດີມ",
    "password": "ລະຫັດຜ່ານ",
    "phone": "ເລກໝາຍໂທລະສັບ",
    "pleChoose": "ກະລຸນາເລືອກວັນເດືອນປີເກີດ",
    "post": "ໂພສ",
    "postPlaceholder": "ກະລຸນາໃສ່ໂພສ",
    "religion": "ສາສະໜາ",
    "religionPlaceholder": "ກະລຸນາເລືອກສາສະໜາ",
    "retrievePassword": "ດຶງລະຫັດຜ່ານ",
    "setUp": "ການຕັ້ງຄ່າ",
    "signOut": "ອອກຈາກລະບົບ",
    "something": "ຂ້າພະເຈົ້າຕ້ອງການເວົ້າ",
    "submit": "ສົ່ງ",
    "sureDelte": "ກະລຸນາກວດສອບວ່າທ່ານຕ້ອງການລຶບມັນບໍ່?",
    "teacher": "ອາຈານ",
    "learnYet": "ຍັງບໍ່ໄດ້ເລີ່ມຮຽນຮູ້",
    "uName": "ຊື່ຜູ້ໃຊ້",
    "uNamePlaceholder": "ຊື່ຜູ້ໃຊ້",
    "userCenter": "ຂໍ້ມູນສ່ວນຕົວ",
    "username": "ຊື່ຜູ້ໃຊ້",
    "validateMsg": "ການຢືນຢັນລົ້ມເຫຼວ",
    "woman": "ຍິງ",
    "learnTo": "ຄວາມຄືບໜ້າ",
    "myRecord": "ບັນທຶກຂອງຂ້າພະເຈົ້າ",
    "plePhone": "ກະລຸນາໃສ່ເລກໝາຍໂທລະສັບ"
  },
  "notice_zlb": {
    "delete": "ລຶບ",
    "home": "ໜ້າທຳອິດ",
    "lettre": "ຂໍ້ຄວາມສ່ວນຕົວ",
    "lettreEmpty": "ຂໍ້ຄວາມສ່ວນຕົວບໍ່ສາມາດວ່າງໄດ້",
    "messageDetail": "ລາຍລະອຽດຂໍ້ຄວາມ",
    "myMessage": "ຂໍ້ຄວາມຂອງຂ້າພະເຈົ້າ",
    "notice": "ແຈ້ງການ",
    "nowBavarder": "ຕອນນີ້ທ່ານສາມາດເລີ່ມສົນທະນາໄດ້",
    "send": "ສົ່ງ"
  },
  "play_zlb": {
    "networkTip": "ການແຈ້ງເຕືອນເຄືອຂ່າຍ",
    "streamHighTip": "ການເຊື່ອມຕໍ່ເຄືອຂ່າຍປັດຈຸບັນມີຄວາມສະຖຽນ. ພວກເຮົາໄດ້ປ່ຽນໄປໃຊ້ຮູບແບບຄວາມລະອຽດສູງສຳລັບທ່ານ.",
    "streamHighType": "HD",
    "streamNormTip": "ການເຊື່ອມຕໍ່ເຄືອຂ່າຍປັດຈຸບັນບໍ່ສະຖຽນ. ພວກເຮົາໄດ້ປ່ຽນໄປໃຊ້ຮູບແບບຄວາມລະອຽດມາດຕະຖານສຳລັບທ່ານ. ",
    "streamNormType": "SD",
    "liveTimeDes": "ເວລາຖ່າຍທອດສົດ",
    "livePlayWait": "ຍັງບໍ່ເລີ່ມຖ່າຍທອດສົດ",
    "livePlayEnd": "ການຖ່າຍທອດສົດສິ້ນສຸດແລ້ວ"
  },
  "questionnaire_zlb": {
    "handed": "ສົ່ງ",
    "saveFailed": "ບັນທຶກລົ້ມເຫຼວ",
    "examList": "ລາຍການຄຳຖາມທົດສອບ"
  },
  "research_zlb": {
    "afternoon": "ຫຼັງທ່ຽງ",
    "all": "ທັງໝົດ",
    "allCalendar": "ວາລະທັງໝົດ",
    "alumniBook": "ສະມາຊິກ",
    "broadcast": "x ເລີ່ມອອກອາກາດ",
    "carriedout": "ກຳລັງດຳເນີນການ",
    "certificate": "ໃບຢັ້ງຢືນ",
    "comment": "ສະແດງຄວາມຄິດເຫັນ",
    "comments": "ຄຳເຫັນ x ທັງໝົດ",
    "courses": "ເອກະສານອ້າງອີງ",
    "curDis": "ກຳລັງດຳເນີນການ",
    "default": "ຍັງບໍ່ເລີ່ມ",
    "delete": "ລຶບ",
    "detail": "ລາຍລະອຽດ",
    "discuss": "ເວທີສົນທະນາ",
    "end": "ສິ້ນສຸດແລ້ວ",
    "endAssess": "ການປະເມີນຜົນສິ້ນສຸດແລ້ວ",
    "enterAssess": "ເລີ່ມການປະເມີນຜົນ",
    "assessButton": "ຄຳຕິຊົມ",
    "evaluation": "ການປະເມີນຜົນ",
    "fileAcept": "ປະເພດໄຟລ໌ບໍ່ຖືກຕ້ອງ, ກະລຸນາອັບໂຫຼດອີກຄັ້ງ.",
    "fileSize10": "ໄຟລ໌ທີ່ເລືອກມີຄວາມຍາວເກີນ 10m, ກະລຸນາອັບໂຫຼດອີກຄັ້ງ.",
    "hisDis": "ປະຫວັດ",
    "lecture": "ເອກະສານອ້າງອີງ",
    "live": "ຖ່າຍທອດສົດ",
    "livebroadcast": "ການຖ່າຍທອດສົດ",
    "minutes": "x ນາທີກ່ອນ",
    "month": "ເດືອນ",
    "morning": "ກ່ອນທ່ຽງ",
    "noDiscussion": "ບໍ່ມີການປະຊຸມວິຊາການ",
    "noSchedule": "ບໍ່ມີວາລະ",
    "notice": "ແຈ້ງການ",
    "notification": "ແຈ້ງການທີ່ຍັງບໍ່ໄດ້ອ່ານ",
    "offline": "ການບັນຍາຍແບບຕົວຕໍ່ຕົວ",
    "onging": "ກຳລັງດຳເນີນການ",
    "online": "ອອນລາຍ",
    "operation": "ການມອບໝາຍ",
    "over": "ສິ້ນສຸດແລ້ວ",
    "participated": "ເຂົ້າຮ່ວມແລ້ວ",
    "notParticipate": "ຍັງບໍ່ທັນເຂົ້າຮ່ວມ",
    "failedCourse": "ບໍ່ຜ່ານ",
    "passedCourse": "ຜ່ານ",
    "preparation": "ການກະກຽມວຽກງານ",
    "preparations": "ການກະກຽມວຽກງານ",
    "preschoolLecture": "ການບັນຍາຍອຸ່ນເຄື່ອງ",
    "questionnaire": "ແບບສອບຖາມ",
    "questionType ": "ຫຼາຍທາງເລືອກ (ຄຳຕອບດຽວເທົ່ານັ້ນທີ່ຖືກຕ້ອງ, ໝາຍທຸກຄໍາຕອບທີ່ບໍ່ຖືກຕ້ອງອອກ)",
    "readySay": "ຂ້າພະເຈົ້າຕ້ອງການເວົ້າ",
    "replies": "ທ່ານມີ x ການຕອບກັບໃໝ່",
    "save": "ບັນທຶກ",
    "schedule": "ວາລະ",
    "searchC": "ຊອກຫາຫົວຂໍ້ທີ່ທ່ານສົນໃຈ",
    "seeAssess": "ເບິ່ງການປະເມີນຜົນ",
    "submit": "ສົ່ງ",
    "submitHomewor": "ຍົກເລີກ",
    "task": "ວຽກງານ",
    "taskToday": "ວຽກງານສຳລັບມື້ນີ້",
    "video": "ວີດີໂອ",
    "week": "ອາທິດ",
    "yourcomment": "ຂຽນຄວາມຄິດເຫັນຂອງທ່ານ",
    "legend": "ຕຳນານ",
    "sunday": "ວັນອາທິດ",
    "monday": "ວັນຈັນ",
    "tuesday": "ວັນອັງຄານ",
    "wednesday": "ວັນພຸດ",
    "thursday": "ວັນພະຫັດ",
    "friday": "ວັນສຸກ",
    "saturday": "ວັນເສົາ",
    "consult": "ເອກະສານອ້າງອີງ",
    "schedules": "ວຽກງານ",
    "calendar": "ປະຕິທິນ",
    "waitAssesment": "ແບບສອບຖາມທີ່ຈະສົ່ງ",
    "year": "ປີ",
    "day": "ວັນ",
    "preview": "ເບິ່ງຕົວຢ່າງ",
    "resource": "ດາວໂຫຼດ"
  },
  "retrieve_zlb": {
    "emailEmpty": "ທີ່ຢູ່ອີເມວບໍ່ສາມາດວ່າງເປົ່າໄດ້.",
    "emailVerif": "ການຢືນຢັນອີເມວ"
  },
  "task_zlb": {
    "downF": "ດາວໂຫຼດເອກະສານຄັດຕິດ",
    "repeatUp": "ອັບໂຫຼດຄືນໃໝ່",
    "ruY": "ຖ້າເອກະສານຄັດຕິດໃດໜຶ່ງໄດ້ຖືກອັບໂຫຼດໃນ  APP, ມັນຖືກຂຽນທັບ ຖ້າທ່ານອັບໂຫຼດຢູ່ໃນຄອມພິວເຕີອີກ.",
    "submitC": "ກະລຸນາໃສ່ສິ່ງທີ່ທ່ານຕ້ອງການສົ່ງ",
    "uploadF": "ອັບໂຫຼດເອກະສານຄັດຕິດ"
  },
  "upload_zlb": {
    "clickHere": "ຄລິກທີ່ນີ້",
    "limit": "ຮູບແບບໄຟລ໌ຮອງຮັບ PNG, ຂະໜາດ JPG ຕ້ອງບໍ່ເກີນ",
    "preview": "ເບິ່ງຕົວຢ່າງຫຼັງຈາກອັບໂຫຼດຮູບພາບ",
    "upload": "ອັບໂຫຼດ"
  },
  "index": {
    "setAsHomePage": "ຕັ້ງເປັນໜ້າທຳອິດ",
    "addCollection": "ເພີ່ມໃສ່ລາຍການທີ່ມັກ",
    "telephone": "ສາຍດ່ວນ",
    "Help": "ສູນຊ່ວຍເຫຼືອ",
    "SystemMessage": "ການແຈ້ງເຕືອນລະບົບ",
    "message": "ຂໍ້ຄວາມສ່ວນຕົວ",
    "emptyMessage": "ຊັດເຈນ",
    "checkAllMessage": "ເບິ່ງທັງໝົດ",
    "noMessage": "ບໍ່ມີຂໍ້ມູນ",
    "fullScreen": "ການສະແດງຜົນເຕັມໜ້າຈໍ",
    "ExitSystem": "ອອກຈາກລະບົບນີ້",
    "back": "ກັບຄືນ",
    "top": "ທາງເທິງ",
    "backToTop": "ກັບໄປທາງເທິງ",
    "homePage": "ໜ້າທຳອິດ",
    "favoriteTips": "ເນື່ອງຈາກຂໍ້ຈຳກັດຂອງໂປຣແກຣມທ່ອງເວັບ 360 / ໂປຣແກຣມທ່ອງເວັບ Google, ກະລຸນາກົດ Ctrl + D ເພື່ອເກັບກຳດ້ວຍຕົນເອງ!",
    "autoSetHomeTips": "ໂປຣແກຣມທ່ອງເວັບຂອງທ່ານບໍ່ຮອງຮັບການຕັ້ງຄ່າໜ້າທຳອິດໂດຍອັດຕະໂນມັດ, ກະລຸນາໃຊ້ເມນູຂອງໂປຣແກຣມທ່ອງເວັບເພື່ອຕັ້ງຄ່າດ້ວຍຕົນເອງ!",
    "currentUser": "ຜູ້ໃຊ້ປັດຈຸບັນ",
    "userHead": "ຮູບໂປຣໄຟລ໌",
    "accountPassword": "ລະຫັດຜ່ານບັນຊີ",
    "change": "ອັບເດດ",
    "head": "ຮູບໂປຣໄຟລ໌",
    "continueStudy": "ສືບຕໍ່",
    "startStudy": "ເລີມຮຽນຮູ້"
  },
  "course": {
    "count": "ທົ່ວໄປ",
    "item": "ບົດຄວາມ",
    "up": "ໜ້າກ່ອນ",
    "next": "ໜ້າຕໍ່ໄປ",
    "items": "ຕໍ່ໜ້າ",
    "go": "ຂ້າມໄປທີ່",
    "page": "ໜ້າ",
    "man": "ຜູ້ໃຊ້",
    "score": "ຄະແນນ",
    "courseYear": "ປີ",
    "courseTeachers": "ອາຈານ",
    "noDesc": "ບໍ່ມີຄຳນຳ",
    "teachersDesc": "ຂໍ້ມູນຂອງຄູ",
    "checkLog": "ເບິ່ງບັນທຶກ",
    "startStudy": "ເລີມຮຽນຮູ້",
    "JoinLearning": "ເຂົ້າຮ່ວມ",
    "isEvaluate": "ປະເມີນແລ້ວ",
    "deleteNoteButton": "ລຶບ",
    "closeButton": "ປິດ",
    "noteSource": "ຈາກ"
  },
  "onlineclass": {
    "myScore": "ຄະແນນຂອງຂ້າພະເຈົ້າ",
    "comments": "ສະແດງຄວາມຄິດເຫັນ",
    "iknow": "ຂ້າພະເຈົ້າຮູ້ວ່າ",
    "detail": "ລາຍລະອຽດ",
    "inforCertificate": "ໃບຢັ້ງຢືນ",
    "wantTalk": "ຂ້າພະເຈົ້າຕ້ອງການສະແດງຄວາມຄິດເຫັນ",
    "inputTalkContent": "ກະລຸນາໃສ່ຄວາມຄິດເຫັນ",
    "publish": "ເຜີຍແຜ່",
    "undo": "ຍົກເລີກ",
    "reply": "ຕອບກັບ",
    "delete": "ລຶບ",
    "Learned": "ສຳເລັດສົມບູນ",
    "isDelete": "ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບມັນ?",
    "submitTime": "ເວລາສົ່ງ",
    "to": "ເຖິງ",
    "download": "ດາວໂຫຼດ"
  },
  "usercenter": {
    "htllo": "ສະບາຍດີ",
    "welcomeMessage": "ຂໍໃຫ້ເປັນວັນທີ່ມີຄວາມສຸກ",
    "searchTips": "ຊອກຫາຫຼັກສູດທີ່ທ່ານມັກ",
    "myCertificate": "ໃບຢັ້ງຢືນຂອງຂ້າພະເຈົ້າ",
    "startQuestionnaire": "ເລີ່ມຂຽນຄຳຕອບ",
    "empty": "ບໍ່ມີຫຍັງ",
    "confirmDelete": "ຢືນຢັນການລຶບ",
    "confirmDeleteTips": "ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບມັນ?",
    "delete": "ລຶບ",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "ສິ້ນສຸດການຮຽນຮູ້",
    "tips": "ຄຳແນະນຳ",
    "playTips": "ຄຳແນະນຳ: ກະລຸນາຄລິກປຸ່ມ \"ສິ້ນສຸດການຮຽນຮູ້\" ຢູ່ແຈຂວາເທິງເພື່ອອອກ. ຖ້າທ່ານເຊົາຮຽນຮູ້ໂດຍການປິດໂປຣແກຣມທ່ອງເວັບ, ເວລາຂອງການຮຽນຮູ້ຂອງທ່ານອາດຈະບັນທຶກບໍ່ຖືກຕ້ອງ.",
    "notShowAgain": "ຢ່າເຕືອນຂ້າພະເຈົ້າອີກ",
    "gotIt": "ຂ້າພະເຈົ້າຮູ້ວ່າ",
    "chapter": "ບົດ",
    "language": "ພາສາ",
    "chapterText1": "ເລກທີ",
    "chapterText2": "ບົດ",
    "note": "ບັນທຶກ",
    "noteBlockTitle": "ບັນທຶກ",
    "evaluate": "ການປະເມີນຜົນ",
    "evaluateStar": "ດາວ",
    "saveEvaluate": "ສົ່ງ",
    "notePlaceholder": "ກະລຸນາຈົດບັນທຶກ",
    "closeTips": "ການປ່ຽນແປງທີ່ທ່ານເຮັດອາດຈະບໍ່ໄດ້ຮັບການບັນທຶກ",
    "closeButton": "ອອກຈາກ",
    "autoStop": "ຢຸດຫຼິ້ນໂດຍອັດຕະໂນມັດ",
    "autoStopTips": "ໝົດເວລາການໃຊ້ງານຂອງຜູ້ໃຊ້. ການຫຼິ້ນຄືນຈະຢຸດໂດຍອັດຕະໂນມັດ.",
    "confirmOut": "ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການເຊົາຫຼິ້ນ?",
    "closeOrNot": "ປິດໜ້າຕ່າງປັດຈຸບັນ",
    "noCoursePlay": "ບໍ່ພົບເຫັນແຫຼ່ງຂໍ້ມູນທີ່ສາມາດຫຼິ້ນໄດ້ໃນຫຼັກສູດປັດຈຸບັນ",
    "attention": "ເຊີນຊາບ!"
  },
  "assessment_zlb": {
    "score": "ຄະແນນ",
    "evalSuccess": "ການປະເມີນຜົນສຳເລັດ"
  },
  "undefined": {}
};